import React, {useState, useCallback, useEffect} from 'react';
import {useSelector} from 'react-redux';
import {useMutation} from 'react-query';
import {toast} from 'react-toastify';
import {Disclosure} from '@headlessui/react';
import {updateChargeSource} from 'requests/queries/baas';
import {arrowRight} from 'assets/images/images';

function ChargeSource({chargeSource}) {
  const {company} = useSelector(state => state?.auth?.userDetails || {});
  const [selectedChargeSource, setSelectedChargeSource] = useState(
    chargeSource || 'pool',
  );

  const createChargeSourceMutation = useMutation(updateChargeSource);

  useEffect(() => {
    setSelectedChargeSource(chargeSource || 'pool');
  }, [chargeSource]);

  const handleChargeSourceChange = useCallback(
    async e => {
      const newChargeSource = e.target.value;
      setSelectedChargeSource(newChargeSource);

      try {
        await createChargeSourceMutation.mutateAsync({
          charge_source: newChargeSource,
          company_id: company?.id,
        });
        toast.success('Charge configured Successfully!');
      } catch (error) {
        toast.error(
          error.response?.data?.error || 'Failed to update charge source',
        );
      }
    },
    [company?.id, createChargeSourceMutation],
  );

  return (
    <div className="w-full mt-6">
      <Disclosure>
        {({open}) => (
          <>
            {open && (
              <h2 className="text-body text-xs font-medium mb-6 uppercase">
                CHARGE SOURCE
              </h2>
            )}
            <Disclosure.Button className="flex w-full bg-white rounded justify-between mt-6 items-center py-7 px-6 text-left">
              <span className="text-body text-[14px] font-medium">
                {open
                  ? 'Select to charge fees from pool account or user wallet'
                  : 'Charge Source'}
              </span>
              <img
                src={arrowRight}
                alt="chevron-right"
                className={`${open ? 'hidden' : ''}`}
              />
            </Disclosure.Button>
            <Disclosure.Panel className="px-6 pb-6 pt-0 bg-white rounded">
              <div
                className={`w-full ${
                  createChargeSourceMutation.isLoading ? 'opacity-60' : ''
                }`}
              >
                <div>
                  <label className="flex flex-row cursor-pointer w-fit text-[#84858D] text-sm gap-2 items-center">
                    <input
                      type="radio"
                      name="chargeSource"
                      value="pool"
                      checked={selectedChargeSource === 'pool'}
                      onChange={handleChargeSourceChange}
                      className="w-5 h-5"
                      disabled={createChargeSourceMutation.isLoading}
                    />
                    Pool Account (Default)
                  </label>
                  <label className="flex flex-row cursor-pointer w-fit text-[#84858D] text-sm gap-2 items-center mt-6">
                    <input
                      type="radio"
                      name="chargeSource"
                      value="wallet"
                      checked={selectedChargeSource === 'wallet'}
                      onChange={handleChargeSourceChange}
                      className="w-5 h-5"
                      disabled={createChargeSourceMutation.isLoading}
                    />
                    User Wallet
                  </label>
                </div>
              </div>
            </Disclosure.Panel>
          </>
        )}
      </Disclosure>
    </div>
  );
}

export default ChargeSource;
